const toggleCartDrawer = () => {
    const drawer = document.querySelector(".cart-drawer-container")
    const isOpen = drawer.classList.contains("show-cart-drawer")
    if (isOpen) {
        drawer.classList.remove("show-cart-drawer");
        bodyScrollLock.enableBodyScroll(document.body);
    } else {
        drawer.classList.add("show-cart-drawer");
        bodyScrollLock.disableBodyScroll(document.body);
    }
}

// to reuse this function accross app
window.utilityFn = window.utilityFn || {}
window.utilityFn.toggleCartDrawer = toggleCartDrawer;





// ============ Product Card - Add to cart ============


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".add-to-cart-btn").forEach(btn => {
        btn.addEventListener("click", async () => {
            const variant_id = btn.closest(`.product-card`).getAttribute('data-variant-id')
            const quantity = 1;
            if (!variant_id) return;

            // disable add to cart btn 
            const currentBtn = btn.closest(`.product-card[data-variant-id="${variant_id}"]`)?.querySelector('.add-to-cart-btn')
            if (currentBtn) {
                currentBtn.classList.add("disabled")
            }

            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: variant_id, quantity, sections: 'cart-drawer' }),
                })

                const data = await response.json()
                if (!response.ok) {
                    throw new Error(data.message | "Couldn't add to cart")
                }

                const htmlString = data.sections['cart-drawer'];
                const html = document.createElement("div")
                html.innerHTML = htmlString;
        
                const updatedCartItems = html.querySelector(".drawer__cart-product");
                const currentCartItems = document.querySelector(".drawer__cart-product")
        
                if (updatedCartItems && currentCartItems) {
                  currentCartItems.innerHTML = updatedCartItems.innerHTML;
                  window.utilityFn.toggleCartDrawer()
                }

            } catch (error) {
                window.alert(error.message | toString(error))
            } finally {
                currentBtn.classList.remove("disabled")
            }
        })
    })
})



// ======== COLLECTION PAGE FILTERS ================

document.addEventListener("DOMContentLoaded", () => {
    const filterSections = document.querySelectorAll(".filter-option");

    filterSections.forEach((filterSection) => {
        const checkboxes = filterSection.querySelectorAll(".filter-list li input[type='checkbox']");
        const applyButton = filterSection.querySelector(".dropdown-footer button[type='submit']");
        if (applyButton) {
            applyButton.disabled = true;
        }

        const toggleApplyButton = () => {
            const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
            if (applyButton) {
                applyButton.disabled = !isChecked;
            }
        };

        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", toggleApplyButton);
        });

        toggleApplyButton();
    })
})


// ============ Search Product Drawer ===============


document.addEventListener("DOMContentLoaded", () => {
    const input = document.querySelector("#search-product-drawer-input");
    const searchResultsWrapper = document.querySelector(".search-drawer-results-wrapper")

    if (input) {
        let lastSearchQuery = '';
        const searchProducts = async (e) => {
            try {
                const value = e.target.value.trim();
                if (!value) {
                    searchResultsWrapper.innerHTML = '';
                    return;
                }
                if (value === lastSearchQuery) return;
                lastSearchQuery = value;

                searchResultsWrapper.innerHTML = '';
                
                const response = await fetch(`/search/suggest.json?${new URLSearchParams({
                    q: value,
                    'resources[limit]': 4,
                    'resources[type]': 'product',
                    'resources[options][unavailable_products]': 'last'
                }).toString()}`)

                const data = await response.json()
                if (!response.ok) {
                    window.alert(data.message || "Couldn't search products")
                }

                const productsArray = data.resources?.results?.products || []
                if (Array.isArray(productsArray) && productsArray. length > 0) {
                    console.log(productsArray)

                    const productList = document.createElement("ul")
                    productList.classList.add("search-product-list")

                    productsArray.forEach(product => {
                        const productItem = document.createElement("li")
                        productItem.classList.add("search-product-item")

                        const item =  `
                        <a href="${product.url}" class="search-product-card">
                          <img src="${product.featured_image.url}" alt="${product.featured_image.alt}" />
                          <p class="--utils-line-clamp-1">${product.title}</p>
                        </a>
                        
                        `

                        productItem.innerHTML = item;
                        productList.appendChild(productItem)
                    })
                    searchResultsWrapper.appendChild(productList)

                    const viewAllLink = document.createElement("a")

                    const params = new URLSearchParams({
                        q: lastSearchQuery,
                        type: 'product',
                        'options[prefix]': 'last'
                      });
                    
                    viewAllLink.href = `/search?${params.toString()}`
                    viewAllLink.classList.add("view-all-product")
                    viewAllLink.textContent = "View all"
                    searchResultsWrapper.appendChild(viewAllLink)

                } else {
                    const notFound = document.createElement("div")
                    notFound.classList.add("no-product-found")
                    notFound.textContent = `Oops! No results found for - ${lastSearchQuery}`
                    searchResultsWrapper.appendChild(notFound)
                }

            } catch (err) { 
             console.log(err)   
            }
        };

        input.addEventListener("input", debounce(searchProducts, 500));
    }
});


function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}